import {IconSizeColorProps} from "./types";

export default function InfoRoundIcon({
    size = 16,
    color = '#F14141',
    ...props
                                      }:IconSizeColorProps) {
    return <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="8" cy="8" r="8" fill={color}/>
        <path d="M8 4V8.8" stroke="white" strokeWidth="1.2" strokeLinecap="round"/>
        <circle cx="8.0002" cy="11.2004" r="0.8" fill="white"/>
    </svg>


}